module.exports = __webpack_public_path__ + "static/header-6508bccaec49a69a20474619570271f9.jpg";